export default __webpack_public_path__ + "static/media/icon_xtz.a355ac44.svg";